module.exports = __webpack_public_path__ + "img/SINGLE MAGAZINE UNLOADER (CE Type).516abb31.jpg";